import { File } from 'types/models/File';

const resolveVideoUrl = ({ path = '' }: File): string => path.replace('cf://', '');

export default resolveVideoUrl;
